import {Injectable} from '@angular/core';
import {BaseService} from './base.service';
import {APIConfig} from '../app.constant';
import {Observable} from 'rxjs/Observable';
import {User} from '../models/user.model';
import {HttpHeaders} from '@angular/common/http';
import {SessionService} from './session.service';

@Injectable()
export class AuthService extends BaseService {

  doLogin(username, password): Observable<string> {
    this.options = {headers: new HttpHeaders().set('Authorization', 'Token ' + SessionService.apiToken)};
    return this.http.post<string>(APIConfig.API_LOGIN_URL, {'username': username, 'password': password});
  }

  doLogout(): Observable<string> {
    this.options = {headers: new HttpHeaders().set('Authorization', 'Token ' + SessionService.apiToken)};
    return this.http.get<string>(APIConfig.API_LOGOUT_URL, this.options);
  }

  getUser(): Observable<User> {
    this.options = {headers: new HttpHeaders().set('Authorization', 'Token ' + SessionService.apiToken)};
    return this.http.get(APIConfig.API_USER_URL, this.options);
  }

}



// WEBPACK FOOTER //
// C:/Users/Pujaalaxmi.K/Documents/PAA-Angular version 2/src/app/services/auth.service.ts